import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Renderiza el markdown liviano que produce Maqui (**negrita**, *itálica*,
 * `código`, viñetas y saltos de línea) a HTML seguro.
 *
 * Seguridad: PRIMERO escapa todo el HTML de la respuesta del modelo, y RECIÉN
 * DESPUÉS agrega sus propias etiquetas (strong/em/code/br). Como lo del modelo ya
 * quedó escapado, no hay forma de inyectar HTML — por eso el bypass es seguro.
 */
@Pipe({ name: 'maquiMd', standalone: true, pure: true })
export class MaquiMarkdownPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): SafeHtml {
    if (!value) return '';

    let s = value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    // **negrita** (antes que la itálica para no pisar los dobles asteriscos)
    s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    // *itálica* y _itálica_
    s = s.replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>');
    s = s.replace(/(^|[^_\w])_([^_\n]+)_/g, '$1<em>$2</em>');
    // `código` inline
    s = s.replace(/`([^`]+)`/g, '<code>$1</code>');
    // viñetas al inicio de línea (- o *) → •
    s = s.replace(/^[ \t]*[-*]\s+/gm, '• ');
    // saltos de línea
    s = s.replace(/\n/g, '<br>');

    return this.sanitizer.bypassSecurityTrustHtml(s);
  }
}
